import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {AlertController, ModalController} from '@ionic/angular';
import {BarcodescannerComponent} from '../../modals/barcodescanner/barcodescanner.component';
import {EquipListReturnPage} from '../../modals/equip-list-return/equip-list-return.page';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {AndroidPermissions} from '@ionic-native/android-permissions/ngx';
import {PicturesPermissionService} from '../../services/pictures-permission.service';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {PatientDTOModel} from '../../models/patientDTO.model';

@Component({
    selector: 'items-return',
    templateUrl: './items-return.component.html',
    styleUrls: ['./items-return.component.scss'],
})
export class ItemsReturnComponent implements OnInit {

    @Input() document: DocumentModel;
    mobileConfiguration: MobileConfigurationModel;

    constructor(private modalController: ModalController,
                private alertController: AlertController,
                private androidPermissions: AndroidPermissions,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames,
                private picturesPermission: PicturesPermissionService
                ) {
    }

    ngOnInit() {
        this.mobileConfiguration = this.stateManager.getCollection(this.collectionNames.MOBILECONFIGURATION);
    }

    async eqListModal() {
        const modal = await this.modalController.create({
            component: EquipListReturnPage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': this.document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data as DetaillineDTOModel[]) {
                console.log(dataReturned.data);
                this.document.detailLines = dataReturned.data;
                // this.document.patient = new PatientDTOModel();
                // this.document.patient.id = dataReturned.data[0].patientId;
                // this.document.patientId = dataReturned.data[0].patientId;
            }
        });

        return await modal.present();
    }

    async editItemQty(i: number) {
        if (this.document.detailLines[i].typ === 'M'
            || this.document.detailLines[i].typ === 'P'
            || this.document.detailLines[i].plu) {
            const qty = this.document.detailLines[i].qty;
            const alert = await this.alertController.create({
                header: 'Edit Plant',
                message: 'Please adjust the quantity.',
                backdropDismiss: false,
                inputs: [
                    {
                        name: 'itemQty',
                        type: 'number',
                        value: qty,
                        placeholder: 'Enter new Qty'
                    }],
                buttons: [
                    {
                        text: 'Cancel',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                        }
                    },
                    {
                        text: 'Ok',
                        handler: data => {
                            this.document.detailLines[i].qty = data.itemQty;
                        }
                    }
                ]
            });

            await alert.present();

        } else {
            console.log(this.document.detailLines[i].reg);
            if (this.document.detailLines[i].requiredQty) {
                this.confirmFulfillItem(this.document.detailLines[i]);
            }
        }
    }

    async scanBarcode() {
        await this.picturesPermission.checkPermissions();

        const modal = await this.modalController.create({
            component: BarcodescannerComponent,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': this.document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
            }
        });
        return await modal.present();
    }

    async confirmFulfillItem(line: DetaillineDTOModel) {
        const alert = await this.alertController.create({
            header: 'Collect Item',
            message: 'Do you confirm the specific Item is being collected?',
            backdropDismiss: false,
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                },
                {
                    text: 'Ok',
                    handler: data => {
                        line.qty = 1;
                    }
                }
            ]
        });

        await alert.present();
    }
}
